
const OfferTypes = [
    {
        title: 'basic',
        price: 'brak opłat',
        displayTime: 30,
        refreshes: 0
    },
    {
        title: 'basic+',
        price: 39,
        displayTime: 30,
        refreshes: 1
    },
    {
        title: 'premium',
        price: 229,
        displayTime: 30,
        refreshes: 1
    },
    {
        title: 'PakietPremium3',
        price: 597
    },
    {
        title: 'PakietPremium5',
        price: 895
    },
    {
        title: 'PakietPremium10',
        price: 1490
    },
    {
        title: 'PakietPremium20',
        price: 1980
    } 
]

export default OfferTypes;
